import $ from "jquery";
import "magnific-popup";
window.$ = window.jQuery = $;

export const singleModal = () => {
	(($) => {
		if ($("body").hasClass("single-post")) {
			$(".wp-block-image a").magnificPopup({
				type: "image",
				closeOnContentClick: true,
				mainClass: "mfp-no-margins mfp-with-zoom mfp-img-mobile",
				image: {
					verticalFit: true,
				},
				zoom: {
					enabled: true,
					duration: 300,
				},
			});
		}
	})(jQuery);
};

export const tableofContent = () => {
	(($) => {
		document.addEventListener("facetwp-loaded", function () {
			let $i = 0;
			$(".entry-content")
				.find("h2.wp-block-heading,h3.wp-block-heading,h4.wp-block-heading")
				.each(function () {
					let $item = $(this);
					$(this).attr("id", "toc-" + $i);
					let $id = $(this).attr("id");
					let li = $("<li/>");
					let a = $("<a/>", { text: $item.text(), href: "#" + $id, title: $item.text() });
					a.appendTo(li);
					$("#tableContents .toc ol").append(li);
					$i++;
				});
		});

		if ($("body").hasClass("page-template-page-policy", "page-template-page-legal")) {
			let $i = 0;
			$(".entry-content")
				.find("h2.wp-block-heading,h3.wp-block-heading,h4.wp-block-heading")
				.each(function () {
					let $item = $(this);
					$(this).attr("id", "toc-" + $i);
					let $id = $(this).attr("id");
					let li = $("<li/>");
					let a = $("<a/>", { text: $item.text(), href: "#" + $id, title: $item.text() });
					a.appendTo(li);
					$("#tableContents .toc ol").append(li);
					$i++;
				});
		}
	})(jQuery);
};

export const eventAssetsExpand = () => {
	(($) => {
		let e_cnt = 12;
		const el = $(".section-event-assets .row>div"),
			elen = el.length,
			btn_xpnd = $(".section-event-assets .btn-expand");

		if (elen <= 12) {
			btn_xpnd.hide();
		}

		el.slice(0, 12).addClass("show");
		btn_xpnd.click((e) => {
			e.preventDefault();
			e_cnt = e_cnt + 12;
			el.slice(0, e_cnt).addClass("show");

			let s_cnt = $(".section-event-assets .row>.show").length;
			if (elen <= s_cnt) {
				btn_xpnd.hide();
			}
		});
	})(jQuery);
};

export const careersPagination = () => {
	if (document.body.classList.contains("page-careers")) {
		const paginationNumbers = document.getElementsByClassName("pagination-numbers")[0],
			paginatedList = document.getElementsByClassName("row-list")[0],
			listItems = paginatedList.querySelectorAll("a"),
			nextButton = document.getElementsByClassName("btn-next")[0],
			prevButton = document.getElementsByClassName("btn-prev")[0],
			paginationLimit = 10,
			pageCount = Math.ceil(listItems.length / paginationLimit);

		let currentPage = 1;

		const disableButton = (button) => {
			button.classList.add("d-none");
			button.setAttribute("d-none", true);
		};

		const enableButton = (button) => {
			button.classList.remove("d-none");
			button.removeAttribute("d-none");
		};

		const handlePageButtonsStatus = () => {
			if (currentPage === 1) {
				disableButton(prevButton);
			} else {
				enableButton(prevButton);
			}

			if (pageCount === currentPage) {
				disableButton(nextButton);
			} else {
				enableButton(nextButton);
			}
		};

		const handleActivePageNumber = () => {
			document.querySelectorAll(".facetwp-page").forEach((button) => {
				button.classList.remove("active", "show", "ellipse");
				const pageIndex = Number(button.getAttribute("page-index"));

				if (pageIndex == currentPage) {
					button.classList.add("active");
				}
				if (pageIndex == currentPage + 1) {
					button.classList.add("show");
				}
				if (pageIndex == currentPage - 1) {
					button.classList.add("show");
				}
				if (pageIndex == currentPage + 2) {
					button.classList.add("show");
				}
				if (pageIndex == currentPage - 2) {
					button.classList.add("show");
				}
				if (pageIndex == currentPage + 3) {
					button.classList.add("ellipse");
				}
				if (pageIndex == currentPage - 3) {
					button.classList.add("ellipse");
				}
			});
		};

		const appendPageNumber = (index) => {
			const pageNumber = document.createElement("button");
			pageNumber.className = "facetwp-page";
			pageNumber.innerHTML = index;
			pageNumber.setAttribute("page-index", index);
			pageNumber.setAttribute("aria-label", "Page " + index);

			if (index == 1) {
				pageNumber.className = "facetwp-page first";
			}
			if (index == pageCount) {
				pageNumber.className = "facetwp-page last";
			}

			paginationNumbers.appendChild(pageNumber);
		};

		const getPaginationNumbers = () => {
			for (let i = 1; i <= pageCount; i++) {
				appendPageNumber(i);
			}
		};

		const setCurrentPage = (pageNum) => {
			currentPage = pageNum;

			handleActivePageNumber();
			handlePageButtonsStatus();

			const prevRange = (pageNum - 1) * paginationLimit;
			const currRange = pageNum * paginationLimit;

			listItems.forEach((item, index) => {
				item.classList.add("d-none");

				if (index >= prevRange && index < currRange) {
					item.classList.remove("d-none");
				}
			});
		};

		window.addEventListener("load", () => {
			getPaginationNumbers();
			setCurrentPage(1);

			prevButton.addEventListener("click", () => {
				setCurrentPage(currentPage - 1);
			});

			nextButton.addEventListener("click", () => {
				setCurrentPage(currentPage + 1);
			});

			document.querySelectorAll(".facetwp-page").forEach((button) => {
				const pageIndex = Number(button.getAttribute("page-index"));

				if (pageIndex) {
					button.addEventListener("click", () => {
						setCurrentPage(pageIndex);
					});
				}
			});
		});
	}
};

export const careersFilterPagination = () => {
	let paged = 5;
	let row, chunks;
	let pageli = "";

	$(() => {
		$(".page-careers .section-roles .no-results").hide();
		row = $(".page-careers .section-roles .row-list a");
		let departmentChecks = $(".page-careers .section-roles .filter-department .filter-checkbox :checkbox");
		let locationChecks = $(".page-careers .section-roles .filter-location .filter-checkbox :checkbox");
		let departmentSelectors, locationSelectors;

		departmentChecks.change(() => {
			updateResults();
		});

		locationChecks.change(() => {
			updateResults();
		});

		const updateResults = () => {
			pageli = "";
			let results = [];
			departmentSelectors = departmentChecks
				.filter(":checked")
				.map(function () {
					return "." + this.value;
				})
				.get();
			locationSelectors = locationChecks
				.filter(":checked")
				.map(function () {
					return "." + this.value;
				})
				.get();

			if (!departmentSelectors.length && !locationSelectors.length) {
				row.each((i, e) => {
					results.push($(e)[0]);
				});
			}
			if (departmentSelectors.length && !locationSelectors.length) {
				row.each((i, e) => {
					if ($(e).has(departmentSelectors.join()).length > 0) {
						results.push($(e)[0]);
					}
				});
			}
			if (!departmentSelectors.length && locationSelectors.length) {
				row.each((i, e) => {
					if ($(e).has(locationSelectors.join()).length > 0) {
						results.push($(e)[0]);
					}
				});
			}

			if (departmentSelectors.length && locationSelectors.length) {
				row.each((i, e) => {
					if ($(e).has(departmentSelectors.join()).length > 0 && $(e).has(locationSelectors.join()).length > 0) {
						results.push($(e)[0]);
					}
				});
			}

			if (results.length) {
				$(".page-careers .section-roles .no-results").hide();
			} else {
				$(".page-careers .section-roles .no-results").show();
			}

			createPagination(results);
			clickPagination();
		};
		updateResults();

		$(".filter-clear").click(() => {
			departmentChecks.prop("checked", false);
			locationChecks.prop("checked", false);
			updateResults();
		});
	});

	const clickPagination = () => {
		$(".page-careers .pagination a").click(function (e) {
			e.preventDefault();
			row.hide();
			$(".page-careers .pagination a").removeClass("active");
			$(this).addClass("active");
			$(chunks[parseInt($(this).text()) - 1]).show();
		});
	};

	const createPagination = (data) => {
		chunks = new Array(Math.ceil(data.length / paged)).fill("").map(function () {
			return this.splice(0, paged);
		}, data.slice());

		row.hide();

		for (let i = 0; i < chunks.length; i++) {
			if (i == 0) {
				pageli += '<li><a href="#" class="active">' + (i + 1) + "</li>";
			} else {
				pageli += '<li><a href="#">' + (i + 1) + "</li>";
			}
		}

		$(".page-careers .pagination").html(pageli);
		$(chunks[0]).show();
	};
};
